/* eslint-disable */
export function getCaretPosition(element) {
	let selection = window.getSelection()

	if (element.contains(selection.anchorNode)) {
		let range = selection.getRangeAt(0),
			preCaretRange = range.cloneRange()

		preCaretRange.selectNodeContents(element)
		preCaretRange.setEnd(range.endContainer, range.endOffset)
		return preCaretRange.toString().length
	} else {
		return element.innerHTML.length
	}
}

export function setCaretAtPosition(childNode, caretPosition) {
	let selection = window.getSelection(),
		range = document.createRange()

	range.setStart(childNode, caretPosition)
	range.setEnd(childNode, caretPosition)
	selection.removeAllRanges()
	selection.addRange(range)
}

export function encodeCommentValue(input) {
	let nodes = input.childNodes,
		encoded = {
			content: '',
			mentions: []
		}

	for (let i = 0; i < nodes.length; i++) {
		let child = nodes[i]
		if (child.nodeName === '#text') {
			encoded.content += child.data
		} else if (child.nodeName === 'DIV') {
			let user = child.getAttribute('mention')
			encoded.content += ':@mention=' + user + '@:'
			encoded.mentions.push(user)
		} else if (child.nodeName === 'BR') {
			encoded.content += '\n'
		}
	}

	return encoded
}

export function getCaretPositionAndNode(input) {
	if (input.childNodes.length === 0)
		input.appendChild(document.createTextNode(''))

	let caretPosition = getCaretPosition(input),
		childNodes = input.childNodes,
		childNode = input.childNodes[0],
		length = 0,
		response = {
			node: null,
			caretPosition: 0
		}

	for (let i = 0; i < childNodes.length; i++) {
		childNode = childNodes[i]
		let lengthOld = length
		if (childNode.nodeName === '#text') {
			length += childNode.data.length
		} else if (childNode.nodeName === 'DIV') {
			length += childNode.innerText.length
		}

		if (lengthOld <= caretPosition && length >= caretPosition) {
			response.caretPosition = caretPosition - lengthOld
			break;
		}
	}

	response.node = childNode
	return response;
}
